export function parseHeaders (getters, headers) {
  Object.entries(headers).forEach(([key, val]) => {
    let headerValue = null

    if (val && typeof val === 'function') {
      headerValue = val(getters)
    }

    if (val && typeof val !== 'function') {
      headerValue = headers[key]
    }

    if (!headerValue) {
      delete headers[key]
      return
    }

    headers[key] = headerValue
  })
}
